import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import styles from './Modal.module.scss';

const modalRoot =
  typeof document !== 'undefined'
    ? document.getElementById('modal-root')
    : null;

interface Props {
  children?: JSX.Element | React.ReactNode;
  onClose?: () => void;
  containerStyle?: string;
  buttonStyle?: string;
  wrapperStyle?: string;
  contentStyle?: string;
  showCloseButton?: boolean;
}

const Modal = ({
  children,
  onClose,
  containerStyle,
  buttonStyle,
  wrapperStyle,
  contentStyle,
  showCloseButton = false,
}: Props) => {
  if (!modalRoot) {
    return null;
  }
  return ReactDOM.createPortal(
    <div className={classNames(styles.container, containerStyle)}>
      {/* <button className={styles.background} onClick={onClose} /> */}
      <div className={classNames(styles.wrapper, wrapperStyle)}>
        {showCloseButton && (
          <button
            className={classNames(styles.closeButton, buttonStyle)}
            onClick={onClose}
          >
            <Icon type={SvgIcons.CLOSE} width={14} height={14} />
          </button>
        )}
        <div className={classNames(contentStyle)}>{children}</div>
      </div>
    </div>,
    modalRoot,
  );
};

export default Modal;
